// URLs sent to analytics and advertising tags. Password-reset and sign-in
// links carry one-time codes and keys in the query string; those must never
// leave the browser in a page view.

const SENSITIVE_PARAMS = new Set([
  "oobcode",
  "mode",
  "apikey",
  "token",
  "code",
  "continueurl",
  "state",
  "id_token",
  "access_token",
]);

const AUTH_PATHS = ["/reset-password", "/auth", "/login", "/forgot-password"];

export const isAuthPath = (pathname: string): boolean =>
  AUTH_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));

/** Path plus query for analytics: no query at all on auth pages, sensitive parameters removed elsewhere. */
export const analyticsPath = (pathname: string, search: string): string => {
  if (isAuthPath(pathname)) return pathname;
  const params = new URLSearchParams(search);
  Array.from(params.keys()).forEach((key) => {
    if (SENSITIVE_PARAMS.has(key.toLowerCase())) params.delete(key);
  });
  const query = params.toString();
  return query ? `${pathname}?${query}` : pathname;
};

export const analyticsLocation = (): string =>
  `${window.location.origin}${analyticsPath(window.location.pathname, window.location.search)}`;
